import { styled } from "styled-components";
import TableItem from "../../Table/TableItem";
import { ReactComponent as Chevron } from "../../../assets/icons/chevron-left.svg";
import FirstTableItem from "../../Table/FirstTableItem";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: 40px;
`;
export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 3.5px;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${(props) => (props.$fullWidth ? "100%" : "unset")};
  gap: 10px;
`;
export const ChevronLeft = styled(Chevron)`
  cursor: pointer;
`;
export const SectionTitle = styled.h1`
  color: #484888;
  font-family: "Avenir-Heavy";
  user-select: none;
  font-size: 3.5rem;
  letter-spacing: -0.178px;
  text-transform: ${(props) => (props.$capitalize ? "capitalize" : "unset")};

  @media (max-width: 870px) {
  }
`;

export const HeadRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 575px) {
    margin-top: 20px;
  }
  @media (max-width: 590px) {
    flex-direction: column;
    margin-top: 0px;
    gap: 20px;
  }
`;
export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
`;
export const Text = styled.span`
  font-family: "Avenir-Heavy";
  cursor: pointer;
  font-size: 2rem;
  line-height: 27px;
  letter-spacing: -0.177777px;

  color: #484888;
  @media (max-width: 1030px) {
    font-size: 1.6rem;
  }
  @media (max-width: 500px) {
    font-size: 1.4rem;
  }
`;

export const TableContainer = styled.div`
  overflow-x: auto;
  width: 100%;
  margin-top: 80px;
`;

export const StyledTh = styled.th`
  text-align: center;
  font-family: "Avenir";
`;

export const StyledTd = styled.td`
  text-align: center;
  min-width: 150px !important;
`;

export const StyledTdFirst = styled(StyledTd)`
  text-align: left;
  min-width: unset !important;
  padding-bottom: 10px;
  font-family: "Avenir-Medium";
`;

export const StyledTdAll = styled(StyledTd)`
  padding-bottom: 10px;
`;

export const PageCountContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 40px;
  gap: 5px;
`;

export const PageButton = styled.button`
  padding: 2px 7px;
  border: none;
  background: transparent;
  font-family: "Avenir-Medium";
  font-size: 14px;
  color: #484888;
  cursor: pointer;
  &:active {
    opacity: 0.6;
  }
`;

export const LastTableItem = styled(TableItem)`
  justify-content: flex-end;
  padding-right: 16px;
  cursor: ${(props) => (props.$offClick ? "default" : "pointer")};
  text-transform: ${(props) => (props.$capitalize ? "capitalize" : "unset")};

  &:active {
    opacity: ${(props) => (props.$offClick ? 1 : 0)};
  }
`;

export const FirstItem = styled(FirstTableItem)`
  padding-left: 18px;
  text-transform: ${(props) => (props.$capitalize ? "capitalize" : "unset")};
`;
